import { IMenuItem } from 'types/sidebar';

export const MENU_SIDEBAR: IMenuItem[] = [
  /*
  {
    name: 'sidebar.menu.form_sample',
    icon: 'fas fa-copy',
    path: '/form-sample',
  },
  */
  {
    name: 'sidebar.menu.dashboard',
    icon: 'fas fa-columns',
    path: '/',
  },
  {
    name: 'sidebar.menu.cv',
    icon: 'fas fa-copy',
    path: '/cv',
  },
  {
    name: 'sidebar.menu.company',
    icon: 'fas fa-building',
    path: '/company',
  },
  {
    name: 'sidebar.menu.job',
    icon: 'fas fa-laptop',
    path: '/job',
  },
  {
    name: 'sidebar.menu.task',
    icon: 'fas fa-user-check',
    path: '/task',
  },
  {
    name: 'sidebar.menu.user',
    icon: 'fas fa-user',
    path: '/user',
  },
  {
    name: 'sidebar.menu.doc',
    icon: 'fas fa-file',
    path: '/doc',
  },
  {
    name: 'sidebar.menu.role',
    icon: 'fas fa-clipboard-check',
    path: '/role',
  },
  {
    name: 'sidebar.menu.chat',
    icon: 'fas fa-chalkboard-teacher',
    path: '/paragraph-chat',
    children: [
      {
        name: 'sidebar.menu.chat.sale',
        icon: 'fas fa-inbox',
        path: 'paragraph-chat/sale',
      },
      {
        name: 'sidebar.menu.chat.recer_other',
        icon: 'fas fa-receipt',
        path: 'paragraph-chat/recer',
      },
    ],
  },
  {
    name: 'sidebar.menu.kpi',
    icon: 'fas fa-copy',
    path: '/kpi',
    children: [
      {
        name: 'sidebar.menu.kpi.sale',
        icon: 'fas fa-inbox',
        path: 'kpi/sale',
      },
      {
        name: 'sidebar.menu.chat.recer',
        icon: 'fas fa-receipt',
        path: 'kpi/recer',
      },
    ],
  },
  {
    name: 'sidebar.menu.turnovers',
    icon: 'fas fa-hand-holding-usd',
    path: '/turnovers',
  },

  {
    name: 'sidebar.menu.setting',
    icon: 'fas fa-cog',
    path: '/setting',
    children: [
      {
        name: 'sidebar.menu.setting.general',
        icon: 'fas fa-pen-square',
        path: 'setting/general',
      },
      {
        name: 'sidebar.menu.setting.position',
        icon: 'fas fa-location-arrow',
        path: 'setting/position',
      },
      {
        name: 'sidebar.menu.setting.language',
        icon: 'fas fa-language',
        path: 'setting/language',
      },
      {
        name: 'sidebar.menu.setting.skill',
        icon: 'fas fa-layer-group',
        path: 'setting/skill',
      },
      {
        name: 'sidebar.menu.setting.level',
        icon: 'fas fa-level-up-alt',
        path: 'setting/level',
      },
      {
        name: 'sidebar.menu.setting.province',
        icon: 'fas fa-city',
        path: 'setting/province',
      },
      {
        name: 'sidebar.menu.setting.district',
        icon: 'fas fa-building',
        path: 'setting/district',
      },
      {
        name: 'sidebar.menu.setting.status-cv1',
        icon: 'fas fa-id-badge',
        path: 'setting/status-cv1',
      },
      {
        name: 'sidebar.menu.setting.status-cv',
        icon: 'fas fa-id-badge',
        path: 'setting/status-cv',
      },
      {
        name: 'sidebar.menu.setting.partner',
        icon: 'fas fa-house-user',
        path: 'setting/partner',
      },
      {
        name: 'sidebar.menu.setting.tax',
        icon: 'fas fa-money-check-alt',
        path: 'setting/tax',
      },
      {
        name: 'sidebar.menu.setting.rank-company',
        icon: 'fas fa-chart-line',
        path: 'setting/rank-company',
      },
      {
        name: 'sidebar.menu.setting.kpi-sale',
        icon: 'fas fa-money-bill',
        path: 'setting/kpi/sale',
      },
      {
        name: 'sidebar.menu.setting.kpi-recer',
        icon: 'fas fa-money-bill',
        path: 'setting/kpi/recer',
      },
      {
        name: 'sidebar.menu.setting.group-document',
        icon: 'fas fa-file-alt',
        path: 'setting/group-document',
      },
      {
        name: 'sidebar.menu.setting.accounts',
        icon: 'fas fa-user-circle',
        path: 'setting/bank-acc',
      },
      {
        name: 'sidebar.menu.setting.accounts-accounting',
        icon: 'fas fa-user-circle',
        path: 'setting/accounting',
      },
      {
        name: 'sidebar.menu.setting.bill-analysis',
        icon: 'fas fa-chart-pie',
        path: 'setting/bill-analysis',
      },
      {
        name: 'sidebar.menu.setting.status',
        icon: 'fas fa-check-circle',
        path: 'setting/status',
      },
      {
        name: 'sidebar.menu.setting.legal',
        icon: 'fas fa-check-circle',
        path: 'setting/legal',
      },
      {
        name: 'sidebar.menu.setting.zalo.email.content',
        icon: 'fas fa-check-circle',
        path: 'setting/zaloEmail-content',
      },
    ],
  },
  {
    name: 'sidebar.menu.clear_cache',
    icon: 'fas fa-ellipsis-h',
    path: '/clear-cache',
  },
];
